var map = {
	"./pascoa_alema.webp": 4358,
	"./pascoa_barra.webp": 2749,
	"./pascoa_biscoito.webp": 2926,
	"./pascoa_bombom.webp": 4832,
	"./pascoa_brigadeiro.webp": 5016,
	"./pascoa_brow.webp": 8928,
	"./pascoa_brownozes.webp": 6090,
	"./pascoa_caixabrow.webp": 9677,
	"./pascoa_crocante.webp": 4906,
	"./pascoa_domino.webp": 8273,
	"./pascoa_lata.webp": 4044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5968;